import { Buffer } from "buffer";

export type InputMode = "text" | "hex";

export class EncodingError extends Error {}

/** UTF-8 text -> byte buffer. */
export function textToBytes(text: string): Buffer {
  return Buffer.from(text, "utf8");
}

/** Hex string (optionally with spaces / 0x prefix) -> byte buffer. */
export function hexToBytes(hexInput: string): Buffer {
  let hex = hexInput.trim().replace(/\s+/g, "").toLowerCase();
  if (hex.startsWith("0x")) hex = hex.slice(2);
  if (hex.length === 0) return Buffer.alloc(0);
  if (hex.length % 2 !== 0) {
    throw new EncodingError(
      "Hex must have an even number of characters (2 per byte).",
    );
  }
  if (!/^[0-9a-f]*$/.test(hex)) {
    throw new EncodingError(
      "Invalid hex characters. Only 0-9 and a-f are allowed.",
    );
  }
  return Buffer.from(hex, "hex");
}

/** Convert whichever input mode into raw bytes. */
export function inputToBytes(value: string, mode: InputMode): Buffer {
  return mode === "text" ? textToBytes(value) : hexToBytes(value);
}

export function bytesToHex(buf: Buffer): string {
  return buf.toString("hex");
}
